<template>
  <div class="container-list">
    <div class="common-page common-head">
      <div class="common-page common-head-title">
        <i class="icon-tr--detailed" style="padding-right: 5px"></i>
        巡查记录详情
      </div>
    </div>
    <div class="common-page common-body">
      <div class="disease">
        <div class="header"><span class="blue-box"></span>基本信息</div>
        <div class="body plant">
          <div class="">
            <span class="vertical-center">文物建筑名称：{{ dangerInfo.builderName }}</span>
          </div>
          <div>
            <span class="vertical-center">巡查方法：{{ dangerInfo.inspectionMethod }}</span>
          </div>
          <div>
            <span class="vertical-center">巡查人：{{ dangerInfo.nickName }}</span>
          </div>
          <div>
            <span class="vertical-center">巡查范围：{{ dangerInfo.inspectionScope }}</span>
          </div>
          <div>
            <span class="vertical-center">路名门牌：{{ dangerInfo.roadNameDoorplate }}</span>
          </div>
          <div>
            <span class="vertical-center">巡查日期：{{ dangerInfo.inspectionDate }}</span>
          </div>
          <div>
            <span class="vertical-center">极端天气记录：{{ dangerInfo.extremeWeatherRecord }}</span>
          </div>
        </div>
      </div>
      <div class="disease">
        <div class="header"><span class="blue-box"></span>{{ dangerInfo.checkSmall }}</div>
        <div class="body">
          <div class="flex">
            <span class="label vertical-center">结果：</span>
            <el-radio-group class="vertical-center1" :value="dangerInfo.abnormal == 0" disabled>
              <el-radio :label="true">正常</el-radio>
              <el-radio :label="false">异常</el-radio>
            </el-radio-group>
          </div>
          <div class="flex">
            <div class="label vertical-center">位置：</div>
            <el-input class="val" placeholder="请输入内容" :value="dangerInfo.location" :disabled="true"> </el-input>
          </div>
          <div class="flex">
            <div class="label vertical-center">巡查数据：</div>
            <el-input class="val" placeholder="请输入内容" :value="dangerInfo.patrolData" :disabled="true"> </el-input>
          </div>
        </div>
      </div>
      <div class="disease" v-if="dangerInfo.childList && dangerInfo.childList.length > 0">
        <div class="header"><span class="blue-box"></span>巡查图片</div>
        <div class="body" v-for="(item, index) of dangerInfo.childList">
          <div class="vertical-center">
            <strong>照片编号：{{ item.photoNum }}</strong>
          </div>
          <div class="vertical-center" style="display: flex;">
            <span style="width: 50%;">拍摄时间：{{ item.photoTime }}</span
            ><span style="width: 50%;"> 拍摄位置：{{ item.photoLocation }}</span>
          </div>
          <div class="vertical-center">
            <div class="label ">拍摄内容：</div>
            <el-input class="val" placeholder="请输入内容" :value="item.photoContent" :disabled="true"> </el-input>
          </div>
          <div class="vertical-center">
            <div class="label ">文字描述：</div>
            <el-input class="val" placeholder="请输入内容" :value="item.photoDescribe" :disabled="true"> </el-input>
          </div>
          <div class="vertical-center">
            <div class="label ">备注：</div>
            <el-input class="val" placeholder="请输入内容" :value="item.remark" :disabled="true"> </el-input>
          </div>
          <div class="vertical-center" style="grid-row-start: span 5;">
            <div class="label ">照片：</div>
            <el-image v-if="item.photoUrl" class="img" :src="item.photoUrl" alt="" />
          </div>
          <div>
            <el-divider></el-divider>
          </div>
        </div>
      </div>
    </div>
    <el-backtop target=".common-body-style"></el-backtop>
    <div class="btn-box center">
      <el-button type="primary" class="ml20" @click="$router.back()">返回</el-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      id: this.$route.query.id || "",
      dangerInfo: "",
    };
  },
  created() {
    console.log(this.id);
    this.getDetail();
  },
  methods: {
    getDetail() {
      this.$get("/inspection/wenwuInspectionAppChild/selectInfoBySchemeId/" + this.id).then((res) => {
        console.log(res);
        this.dangerInfo = res.data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.common-body {
  text-align: left;
  padding: 0 48px;
  height: calc(100% - 59px);
}

.blue-box {
  background-color: rgba(39, 123, 249, 1);
  width: 6px;
  height: 18px;
  border-radius: 8px;
  display: inline-block;
  margin-right: 12px;
}
.vertical-center {
  display: flex;
  align-items: center;
}
.vertical-center1 {
  display: flex;
  align-items: center;
}
.disease {
  background-color: #f8f8f8;
  // border: #666 1px solid;
  border-radius: 8px;
  padding: 12px;
  margin: 12px;
  display: grid;
  grid-template-columns: 100%;
  grid-gap: 18px;
  .header {
    display: flex;
    align-items: center;
  }
  .body {
    display: grid;

    grid-gap: 12px;
    grid-auto-rows: 40px;
  }
  .plant {
    grid-template-columns: 50% 50%;
  }
  .vertical-center {
    margin-left: 60px;
    // display: flex;
    // align-items: center;
  }
  .label {
    width: 200px;
  }
  .val {
    width: calc(100% - 200px);
  }
  .img {
    border-radius: 8px;
    min-width: 200px;
    max-width: calc(100% - 200px);
    height: 100%;
  }
  .pic-box {
    width: 100%;
    border: 1px solid #666;
  }
}
.btn-box {
  margin: 0;
  padding-bottom: 20px;
}
.el-divider--horizontal {
  display: inline-block;
  background-color: #666;
  background-image: linear-gradient(to right, #fff 50%, #666 0%);
  background-position: top;
  background-size: 20px 1px;
  background-repeat: repeat-x;
}
</style>
